// P180PCM-558: pick the primary image by isPrimary, never array position —
// see the PR/ticket for why. This is the one place that rule lives.

function isPrimary(image: unknown): boolean {
  // === true, not a truthy coercion — a wrapped/stringified CMS boolean must
  // not read as primary.
  return (image as { isPrimary?: boolean } | undefined)?.isPrimary === true
}

function hasUrl(image: unknown): boolean {
  return Boolean((image as { url?: unknown } | undefined)?.url)
}

// -1 means "no images", distinct from the valid index 0. Requires the
// isPrimary match to also have a url, so an unusable primary degrades to
// the first image instead of producing nothing.
function findPrimaryIndex<T>(images?: readonly T[]): number {
  if (!images?.length) {
    return -1
  }
  const index = images.findIndex(image => isPrimary(image) && hasUrl(image))
  return index === -1 ? 0 : index
}

// T defaults to any: resolveSeoMetadata/buildProductSchema call this with
// untyped CMS content, and an unconstrained T infers as {} there instead.
export function getPrimaryImage<T = any>(images?: readonly T[]): T | undefined {
  const index = findPrimaryIndex(images)
  return index === -1 ? undefined : images?.[index]
}

export function getPrimaryImageIndex<T = any>(images?: readonly T[]): number {
  return findPrimaryIndex(images)
}
